import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, FacebookIcon, MapPinIcon, PhoneIcon, MailIcon, DoorOpenIcon } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-69">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z" data-id="element-70" />
    </svg>;
}
export function Footer() {
  return <footer className="relative bg-gradient-to-br from-jet via-[#1a0a1e] to-jet pt-20 pb-10 border-t-4 border-golden overflow-hidden" data-id="element-71">
      {/* Decorative background elements */}
      <div className="absolute inset-0 pattern-african opacity-5 pointer-events-none" data-id="element-72"></div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-burgundy/10 rounded-full blur-3xl pointer-events-none" data-id="element-73"></div>
      <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-brown/10 rounded-full blur-3xl pointer-events-none" data-id="element-74"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-76">
          {/* Brand Col */}
          <div className="space-y-6" data-id="element-77">
            <div className="flex flex-col leading-tight" data-id="element-78">
              <span className="font-heading text-3xl font-bold text-golden tracking-wide" data-id="element-79">
                Beni's
              </span>
              <span className="text-xs uppercase tracking-[0.25em] text-cream/80 font-medium" data-id="element-80">
                African Hair Braiding
              </span>
            </div>
            <p className="text-cream/80 leading-relaxed" data-id="element-81">
              Premium African hair braiding salon dedicated to protective
              styling, healthy hair, and cultural artistry.
            </p>
            <div className="flex gap-4" data-id="element-82">
              <a href="https://www.tiktok.com/@benisafricanbraiding" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-jet/30 flex items-center justify-center text-golden hover:bg-golden hover:text-jet transition-colors" data-id="element-83">
                <TikTokIcon className="w-5 h-5" data-id="element-84" />
              </a>
              <a href="https://www.instagram.com/benisafricanbraiding" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-jet/30 flex items-center justify-center text-golden hover:bg-golden hover:text-jet transition-colors" data-id="element-85">
                <InstagramIcon className="w-5 h-5" data-id="element-86" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-jet/30 flex items-center justify-center text-golden hover:bg-golden hover:text-jet transition-colors" data-id="element-87">
                <FacebookIcon className="w-5 h-5" data-id="element-88" />
              </a>
            </div>
            <div className="mt-4 space-y-2 text-sm text-cream/70" data-id="element-89">
              <a href="https://www.tiktok.com/@benisafricanbraiding" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-golden transition-colors" data-id="element-90">
                <TikTokIcon className="w-4 h-4" data-id="element-91" />
                <span data-id="element-92">@benisafricanbraiding</span>
              </a>
              <a href="https://www.instagram.com/benisafricanbraiding" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-golden transition-colors" data-id="element-93">
                <InstagramIcon className="w-4 h-4" data-id="element-94" />
                <span data-id="element-95">@benisafricanbraiding</span>
              </a>
            </div>
          </div>

          {/* Contact Col */}
          <div data-id="element-96">
            <h4 className="font-heading text-xl font-bold text-cream mb-6" data-id="element-97">
              Contact Us
            </h4>
            <ul className="space-y-4 text-cream/80" data-id="element-98">
              <li className="flex items-start gap-3" data-id="element-99">
                <MapPinIcon className="w-5 h-5 text-golden shrink-0 mt-1" data-id="element-100" />
                <span data-id="element-101">
                  2768 Crain Hwy
                  <br data-id="element-102" />
                  Waldorf, MD 20601
                  <br data-id="element-103" />
                  <span className="text-sm text-cream/60" data-id="element-104">
                    (Beside Heritage Church International)
                  </span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-105">
                <PhoneIcon className="w-5 h-5 text-golden shrink-0 mt-1" data-id="element-106" />
                <div className="flex flex-col" data-id="element-107">
                  <span data-id="element-108">301-710-6221</span>
                  <span data-id="element-109">301-385-8034</span>
                </div>
              </li>
              <li className="flex items-center gap-3" data-id="element-110">
                <MailIcon className="w-5 h-5 text-golden shrink-0" data-id="element-111" />
                <span data-id="element-112">hello@crownglory.com</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-113">
                <DoorOpenIcon className="w-5 h-5 text-golden shrink-0" data-id="element-114" />
                <span className="text-golden font-medium" data-id="element-115">
                  Walk-ins Welcome
                </span>
              </li>
            </ul>
          </div>

          {/* Hours Col */}
          <div data-id="element-116">
            <h4 className="font-heading text-xl font-bold text-cream mb-6" data-id="element-117">
              Hours
            </h4>
            <ul className="space-y-3 text-cream/80" data-id="element-118">
              <li className="flex justify-between border-b border-cream/10 pb-2" data-id="element-119">
                <span data-id="element-120">Tuesday - Friday</span>
                <span className="text-golden" data-id="element-121">9am - 7pm</span>
              </li>
              <li className="flex justify-between border-b border-cream/10 pb-2" data-id="element-122">
                <span data-id="element-123">Saturday</span>
                <span className="text-golden" data-id="element-124">8am - 6pm</span>
              </li>
              <li className="flex justify-between border-b border-cream/10 pb-2" data-id="element-125">
                <span data-id="element-126">Sunday</span>
                <span className="text-golden" data-id="element-127">10am - 4pm</span>
              </li>
              <li className="flex justify-between pb-2" data-id="element-128">
                <span data-id="element-129">Monday</span>
                <span className="text-burgundy font-bold" data-id="element-130">Closed</span>
              </li>
            </ul>
          </div>

          {/* Links Col */}
          <div data-id="element-131">
            <h4 className="font-heading text-xl font-bold text-cream mb-6" data-id="element-132">
              Quick Links
            </h4>
            <ul className="space-y-3 text-cream/80" data-id="element-133">
              <li data-id="element-134">
                <Link to="/services" className="hover:text-golden transition-colors" data-id="element-135">
                  Our Services
                </Link>
              </li>
              <li data-id="element-136">
                <Link to="/about" className="hover:text-golden transition-colors" data-id="element-137">
                  About the Salon
                </Link>
              </li>
              <li data-id="element-138">
                <Link to="/gallery" className="hover:text-golden transition-colors" data-id="element-139">
                  Style Gallery
                </Link>
              </li>
              <li data-id="element-140">
                <Link to="/booking" className="hover:text-golden transition-colors" data-id="element-141">
                  Book Appointment
                </Link>
              </li>
              <li data-id="element-142">
                <a href="#" className="hover:text-golden transition-colors" data-id="element-143">
                  FAQ
                </a>
              </li>
              <li data-id="element-144">
                <a href="#" className="hover:text-golden transition-colors" data-id="element-145">
                  Policies
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-cream/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-cream/60" data-id="element-146">
          <p data-id="element-147">
            &copy; {new Date().getFullYear()} Beni's African Hair Braiding. All
            rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-148">
            <a href="#" className="hover:text-golden transition-colors" data-id="element-149">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-golden transition-colors" data-id="element-150">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}